const globalMixin = {
	computed: {
		isApp() {
			// return true;
			return !this.isNull(window.cordova) && window.cordova != false; // true
		},
			
		isIOS(){
			// return true;
			return (this.isApp && this.getMobileOperatingSystem() == 'iOS');
		},
		siteUrl(){
			return 'https://www.doscast.co.il';
		}
	},
	methods: {
		colorSet() { 
			return [
				'#3366CC',
				'#DC3912',
				'#FF9900',
				'#109618',
				'#990099',
				'#0099C6',
				'#DD4477',
				'#66AA00',
			];			  
		},
		shuffleArray(array) {
			let currentIndex = array.length,
				temporaryValue,
				randomIndex;

			// While there remain elements to shuffle
			while (0 !== currentIndex) {
				// Pick a remaining element
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;

				// Swap it with the current element
				temporaryValue = array[currentIndex];
				array[currentIndex] = array[randomIndex];
				array[randomIndex] = temporaryValue;
			}

			return array;
			},
			
		browser(url){
			if (this.isApp)
			{
				window.openBrowser(url, '_system');
			}
			else 
			{
				window.open(url, '_blank');
			}
			
		},
		alert(msg) {
			this.$swal.fire({ html: msg, confirmButtonText: "אישור" });
		},
		toast(msg, icon ='success', customClass = 'my_toast') {
			return this.$swal.fire({
				icon,
				text: msg,
				toast: true,
				position: 'bottom-start',
				showConfirmButton: false,
				customClass:{
					container: customClass
				},
				timer: 3000 
			});
		},



		errorMsg(msg) {
			this.$swal.fire({ html: msg, confirmButtonText: "אישור", icon: 'error'});
		},
		bg(pic) {
			return "background-image:url(" + pic + ")";
		},
		getMobileOperatingSystem: function() {
			var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		
			// Windows Phone must come first because its UA also contains "Android"
			if (/windows phone/i.test(userAgent)) {
				return "Windows Phone";
			}
		
			if (/android/i.test(userAgent)) {
				return "Android";
			}
		
			// iOS detection from: http://stackoverflow.com/a/9039885/177710
			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				return "iOS";
			}
		
			return "unknown";
		},
		get_word(key) {
			return this.$store.words[key];
		},
	
		format_number: function (x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		isNull: function (str) {
			return str == "" || str == null || str == undefined;
		},

		api(settings, func, failFunc) {
			if (this.isNull(func)) func = function () {};

			var headers = {
				"Content-Type": "application/json; charset=utf-8",
			};

			if (!this.isNull(localStorage.getItem("user_token"))) {
				headers.Authorization = localStorage.getItem("user_token");
			}

			//         var requestOBJ;
			const cancelTokenSource = this.axios.CancelToken.source();

			if (settings.method == "get") {
				let actionGet = settings.action;
				actionGet = actionGet + (actionGet.indexOf("?") === -1 ? "?" : "&");
				actionGet =
					actionGet + "ts=" + new Date().getHours() + "_" + (new Date().getMinutes() < 30 ? "0" : "30");

				if (!this.isNull(settings.data)) {
					for (let i in settings.data) actionGet += "&" + i + "=" + settings.data[i];
				}

				this.axios
					.get(window.api_url + actionGet, { headers: headers, cancelToken: cancelTokenSource.token })
					.then(
						(response) => {
							if (response.data == "error") {
								this.set_user_token("");
								document.location.reload();
							}

							func(response.data);
						},
						(response) => {
							if (!this.isNull(failFunc)) failFunc(response);
							else func(false);
						}
					);

				// Cancel request
				//cancelTokenSource.cancel();
			} else {
				this.axios
					.post(window.api_url + settings.action, settings.data, {
						headers: headers,
						cancelToken: cancelTokenSource.token,
					})
					.then(
						(response) => {
							if (response.data == "error") {
								this.set_user_token("");
								document.location.reload();
							}
							func(response.data);
							//console.log(response.body);
						},
						(response) => {
							if (!this.isNull(failFunc)) failFunc(response);
							//else func(false);
							//console.error(response.body);
						}
					);
			}

			return cancelTokenSource;
		},

		parse_date(str) {
			var d = new Date(str);
			return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
		},

		get_me() {
			return this.$store.user;
		},

		is_subscribed() {
			return this.get_me() && this.get_me().is_subscribed;
		},

		set_user_token(str) {
			localStorage.setItem("user_token", str);
			/*
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        let cookieName = 'app_user';
        let cookieValue = (str == '' ? '0' : '1');
        document.cookie = cookieName +"=" + cookieValue + ";expires=" + myDate + ";domain=.kids.hidabroot.org;path=/";
        */
		},

		logout() {
			localStorage.removeItem("user_token");
			/*
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        let cookieName = 'app_user';
        let cookieValue = '0';
		document.cookie = cookieName +"=" + cookieValue + ";expires=" + myDate + ";domain=.7brachot.co.il;path=/";
*/
			this.$bus.$emit("reload");
			//document.location = '/';
		},

		is_mobile(){

			let check = false;

			
			(function(a){
				//eslint-disable-next-line
				if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		
			/*
			const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

			return toMatch.some((toMatchItem) => {
				return navigator.userAgent.match(toMatchItem);
			});
			*/
		},
		stripTags(html) {
			const tmp = document.createElement("div");
			tmp.innerHTML = html;
			return tmp.textContent || tmp.innerText || "";
		},
		appShare(url){
			var options = {
			url: url,
			message: 'פודקאסט שאהבתי',
			};
			var onSuccess = function() { };
			var onError = function() { };
			window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
		},
		parseTime(time){
			if(time.toFixed() != time) time = time.toFixed();
			var sec_num = parseInt(time, 10); // don't forget the second param
			var hours   = Math.floor(sec_num / 3600);
			var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
			var seconds = sec_num - (hours * 3600) - (minutes * 60);
	
			if (hours   < 10) {hours   = "0"+hours;}
			if (minutes < 10) {minutes = "0"+minutes;}
			if (seconds < 10) {seconds = "0"+seconds;}
			return (hours != '00' ? hours + ':' : '') + minutes + ':' + seconds;
		},
	},
};

export default globalMixin;
